import type { ConfigureOptionDto } from "@/api/configure-options";

export interface MdsFilterState {
  fastenerGroup: string | null;
  feederTracks: string | null;
  forceKn: string | null;
}

/** POC `getMdsProductKey` — e.g. "MDS A100" -> "A100". */
export function getMdsProductKey(
  productId: string,
  productName: string | null,
): string {
  const txt = String(productName || productId || "").toUpperCase();
  const match = txt.match(/A\d{3}/);
  return match ? match[0] : "";
}

function propValue(
  item: ConfigureOptionDto,
  key: string,
): string {
  const hit = item.properties?.find((p) => p.key === key);
  return String(hit?.value ?? "").trim();
}

/** POC `matchesMdsFilterValue`. */
export function matchesMdsFilterValue(
  itemValue: string | null | undefined,
  selectedValue: string | null,
): boolean {
  const raw = String(itemValue ?? "").trim();
  const selected = String(selectedValue ?? "").trim();
  if (!selected) return true;
  if (!raw) return true;
  if (raw.toUpperCase() === "ALL") return true;
  return raw === selected;
}

export function filterMdsCatalogItems(
  items: ReadonlyArray<ConfigureOptionDto>,
  filters: MdsFilterState,
): ConfigureOptionDto[] {
  return items.filter((item) => {
    if (
      !matchesMdsFilterValue(
        propValue(item, "attr_fastener_group"),
        filters.fastenerGroup,
      )
    ) {
      return false;
    }
    if (
      !matchesMdsFilterValue(
        propValue(item, "attr_feeder_tracks"),
        filters.feederTracks,
      )
    ) {
      return false;
    }
    if (
      !matchesMdsFilterValue(
        propValue(item, "attr_force_kn"),
        filters.forceKn,
      )
    ) {
      return false;
    }
    return true;
  });
}

export function countDistinctAppFastenerTypes(
  apps: ReadonlyArray<{ fasteners: ReadonlyArray<{ brand?: string | null; type?: string | null; qtyPerPart?: string | null; qtyPerPartA?: string | null; qtyPerPartB?: string | null }> }>,
): number {
  const keys = new Set<string>();
  for (const app of apps) {
    for (const f of app.fasteners ?? []) {
      const brand = String(f.brand ?? "").trim();
      const type = String(f.type ?? "").trim();
      const key = [brand, type].filter(Boolean).join(" ").toUpperCase();
      if (key) keys.add(key);
    }
  }
  return keys.size || 1;
}
